export var handlerType=function(e,n){var r=n.getEngineVersion(),a=n.getFriendlyName();return{handlerType:r?"".concat(a," (").concat(r,")"):a}};